import React from 'react';
import PropTypes from 'prop-types';

class Item extends React.Component {
  displayComponent = () => {
    const {
      name,
      children,
      isSubcategory,
      isActive,
    } = this.props;

    // Nested list
    if (name !== '' && isSubcategory === 'false') {
      return (
        <li
          onClick={e => this.props.onClick(e)}
          onKeyDown={() => {}}
          role="presentation"
        >
          { name }
          { children }
        </li>

      );
    }

    // Dropdown
    return (
      <li
        className={`bgDropdown ${isActive ? 'active' : ''} `}
        onClick={e => this.props.onClick(e)}
        onKeyDown={() => {}}
        role="presentation"
      >
        { name }
        { children }
      </li>

    );
  }

  render() {
    return (
      this.displayComponent()
    );
  }
}

Item.defaultProps = {
  name: '',
  isSubcategory: '',
  isActive: false,
};

Item.propTypes = {
  name: PropTypes.string,
  isSubcategory: PropTypes.string,
  isActive: PropTypes.bool,
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/Item.jsx